import React from 'react';
import './Skeleton.css';

function Skeleton({ width = '100%', height = '1em', className = '', style, ...props }) {
  return (
    <span
      className={`cw-skeleton${className ? ` ${className}` : ''}`}
      style={{ width, height, ...style }}
      {...props}
    />
  );
}

export default Skeleton;
